import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './components'
import './plugins'
import './style/tailwind.css'
import './style/index.less'
import './assets/iconfont/svg-sprite.js'
import './assets/iconfont/iconfont.js'

import { initAnalytics } from '@/utils/analytics'
import { initMonitor } from '@/utils/monitor'
initAnalytics()
initMonitor()

Vue.config.productionTip = false
Vue.prototype.$feature = FEATURE

Vue.directive('focus', {
  inserted: function(el) {
    el.focus()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
